import { RESPONSE_TYPE } from "../const/vote";
import { BasicTextInput } from "./basic_text/basic-text-input";
import { FirstPastQuestion } from "./check_list/check-list-input";
import { QuestionPreference } from "./preference/preference-input";
import { QuestionInterfaceProps } from "./types";
import { YesNoQuestion } from "./yes_no/yes-no-ballot";

export const QuestionMux = (props: QuestionInterfaceProps<any>) => {
    const { response_type } = props.question;

    switch (response_type) {
        case RESPONSE_TYPE.PREFERENCE:
            return <QuestionPreference {...props} />;

        case RESPONSE_TYPE.CHECK_LIST:
            return <FirstPastQuestion {...props} />;

        case RESPONSE_TYPE.YES_NO:
            return <YesNoQuestion {...props} />;

        case RESPONSE_TYPE.BASIC_TEXT:
            return <BasicTextInput {...props} />
    }
}